"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButtonResultDialog = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const message_dialog_1 = require("../../message-dialog/message-dialog");
const form_1 = require("../../form/form");
exports.ActionButtonResultDialog = react_1.forwardRef(function ActionButtonResultDialog({ FormFields, title, text, onClose }, ref) {
    const dialogRef = react_1.useRef(null);
    const formRef = react_1.useRef(null);
    const handle = react_1.useMemo(() => ({
        open: (data) => {
            var _a, _b;
            (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
            (_b = formRef.current) === null || _b === void 0 ? void 0 : _b.setFieldValues(data);
        },
    }), []);
    react_1.useImperativeHandle(ref, () => handle, [handle]);
    return (react_1.default.createElement(message_dialog_1.MessageDialog, { title: title, ref: dialogRef, onClose: onClose, content: react_1.default.createElement(react_1.default.Fragment, null,
            text !== undefined && react_1.default.createElement(Typography_1.default, null, text),
            react_1.default.createElement(form_1.Form, { ref: formRef, editing: false, onSubmit: lodash_1.noop, initialValues: {} }, react_1.default.createElement(FormFields, null))) }));
});
//# sourceMappingURL=action-button-result-dialog.js.map